/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize EducationalMaterial Categories View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './eventReportEditView';

export const mapStateToPropsEventReportEdit = mapStateToProps;
export const mapDispatchToPropsEventReportEdit = mapDispatchToProps;

export default connect(
  mapStateToPropsEventReportEdit,
  mapDispatchToPropsEventReportEdit
)(View);
